<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,

  props: {
    legendPosition: {
      type: String,
      default: 'top',
    },
    labels: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    dataLabel: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    datasets: {
      type: Array,
      default: () => [],
    },
  },

  mounted() {
    const colors = ['#7F77DD', '#AFA9EC', '#378ADD', '#6FAED9', '#9C8ADE', '#CFA6B8', '#E6D8F2', '#EDC1CF'];
    const chartDatasets = this.datasets.length
      ? this.datasets.map((dataset, index) => ({
          label: dataset.label || '',
          unit: dataset.unit || '',
          precision: dataset.precision,
          backgroundColor: colors[index % colors.length],
          borderColor: '#ffffff',
          borderWidth: 1,
          data: dataset.data || [],
        }))
      : [
          {
            label: this.dataLabel,

            backgroundColor: colors,
            borderColor: '#ffffff',
            borderWidth: 1,

            data: this.data,
          },
        ];
    const chartUnit = chartDatasets.find((dataset) => dataset.unit)?.unit || '';
    const formatValue = (value, dataset) => {
      const precision = parseInt(dataset.precision, 10);
      const numericValue = Number(value);
      if (Number.isNaN(precision) || Number.isNaN(numericValue)) return value;
      return numericValue.toLocaleString(undefined, {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      }) + (dataset.unit ? ` ${dataset.unit}` : '');
    };

    this.renderChart(
      {
        labels: this.labels,
        datasets: chartDatasets,
      },

      {
        responsive: true,
        maintainAspectRatio: false,

        title: {
          display: Boolean(this.title),
          text: this.title,
          fontSize: 11,
          fontStyle: 'normal',
          padding: 8,
        },

        legend: {
          position: this.legendPosition,
          display: chartDatasets.length > 1,
        },

        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const total = dataset.data.reduce((a, b) => a + b, 0);
              const value = dataset.data[tooltipItem.index];
              const percent = total ? ((value / total) * 100).toFixed(1) : '0.0';
              const formattedValue = formatValue(value, dataset);

              const prefix = data.datasets.length > 1 ? `${dataset.label}: ` : '';
              return `${prefix}${data.labels[tooltipItem.index]}: ${formattedValue} (${percent}%)`;
            },
          },
        },

        scales: {
          yAxes: [
            {
                ticks: {
                  beginAtZero: true,
                },
                scaleLabel: {
                  display: Boolean(chartUnit),
                  labelString: chartUnit,
                },
              },
          ],
        },
      },
    );
  },
};
</script>

<style scoped>
div {
  height: 100%;
}
</style>
